import {
  Component,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { APIService } from '../../../../api/api.service';
import { NotifierService } from '../../../../_services/notifier.service';
import { regions } from './../../../../dash/dash.component';

declare let $: any;
declare let flatpickr: any;

@Component({
  selector: 'new-update',
  templateUrl: './update.enableri.component.html',
  styleUrls: ['./update.enableri.component.css'],
})
export class NewSupportUpdateComponent implements OnInit, OnDestroy {
  additionalContacts: string[] = [''];
  userId = localStorage.getItem('eId');
  ut = localStorage.getItem('ut');
  regions: any = regions;
  urlPrefix: any = localStorage.getItem('role') == 'Admin' ? 'admin' : 'client';
  writeAccess: boolean =
    localStorage.getItem('acT') == 'readandwrite' ||
    this.urlPrefix == 'admin' ||
    localStorage.getItem('ut') == 'admin';
  loading = true;
  accountId: any;
  regionId: any;
  dateRange: any;
  RITypes: any = [];
  selectedOption: any;
  currentMessage: any;
  @Output() hideModel = new EventEmitter<any>();
  @Input() ri: any;
  @Input('action') action: any;
  instanceTypes: any;
  platformTypes: any;
  masterAccounts: any;
  mid: any;
  selectedClientName: string;
  selectedChild: { id: number; name: string }[] = [];
  constructor(
    private apiService: APIService,
    private notifier: NotifierService
  ) {}

  ngOnInit(): void {
    this.ri = { ...this.ri };
    console.log('ri', this.ri);
    if (this.action !== 'add') {
      this.ri.ramp = this.ri.ramp === 'Yes';
    }
    $('#mislist').selectpicker();

    $('#childlist').selectpicker();

    this.accountId = localStorage.getItem('accountId');
    this.regionId = localStorage.getItem('regionId');

    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      let d = JSON.parse(msg);
      if (d.value == null) {
        return;
      }
      if (d.key == 'accountId') {
        this.accountId = d.value;
        this.load();
      } else if (d.key == 'regionId') {
        this.regionId = d.value;
        this.load();
      }
    });

    flatpickr('#dataRangePicker', {
      dateFormat: 'Y-m-d',
      mode: 'range',
      showMonths: 2,
      defaultDate: this.dateRange ? this.dateRange.split(' to ') : null,
      onChange: (selectedDates: any, dateStr: any, instance: any) => {
        if (!dateStr.includes('to')) return;
        this.dateRange = dateStr;
      },
    });
    if (this.action !== 'add') {
      this.dateRange = this.ri.startDate + ' to ' + this.ri.endDate;
    }
  }

  load() {
    this.fetchMasterAccounts();
  }

  toggleButton() {
    this.ri.rmp = !this.ri.rmp; // Toggle between true and false
  }

  dropdownOptions: any;

  async fetchMasterAccounts() {
    this.masterAccounts = [];
    this.notifier.loading(true);
    let data = {
      a: 'mids',
    };

    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `https://api.swayam.cloud/v3/admin/billing/lid-mid`;

    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.status == '1' || result.s == '1') {
      this.masterAccounts = result.mids;
      this.mid = this.masterAccounts[0];
    } else {
      this.notifier.alert('Info', '', result.msg, 'info', 5000);
    }
    this.selectedClientName = localStorage.getItem('selectedClientName');
    if (this.action !== 'add') {
      this.selectedOption = this.masterAccounts.find(
        (master: any) =>
          master.name === this.ri.companyName && master.id === this.ri.mid
      );
      this.childFetch(this.selectedOption.clientId);
    }
    setTimeout(() => {
      $('#mislist').selectpicker('refresh');
    }, 0);
    this.notifier.loading(false);
  }

  childs: any;
  async childFetch(id: any) {
    this.notifier.loading(true);
    console.log('id', id);
    let data = {
      a: 'lid',
      clientId: id,
    };
    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `https://api.swayam.cloud/v3/admin/billing/lid-mid`;

    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.status == '1' || result.s == '1') {
      this.childs = result.lids;
    } else {
      this.notifier.alert('Info', '', result.msg, 'info', 5000);
    }

    setTimeout(() => {
      // Refresh the select picker to reflect the updated selectedChild
      ($('#childlist') as any).selectpicker('refresh');
    }, 0);
    
    if (Array.isArray(this.childs) && Array.isArray(this.ri?.lids)) {
      if (this.action !== 'add') {
        // Map the lids to the corresponding child objects from this.childs based on both id and name
        const selectedChildren = this.ri.lids.map((lid:any) => {
          return this.childs.find((child:any) => child.id === lid.id && child.name === lid.name); // Match both id and name
        }).filter((child:any) => child !== undefined); // Filter out undefined values in case no match is found
    
        // Update selectedChild with the matched children
        this.selectedChild = selectedChildren;
        console.log('Selected Child:', this.selectedChild);
      }
    }

    this.notifier.loading(false);
  }

  selectAllchilds(event: any) {
    const isChecked = event.target.checked;
  
    if (isChecked) {
      // Select all accounts
      this.selectedChild = this.childs;
    } else {
      // Deselect all accounts
      this.selectedChild = [];
    }
  
    console.log("Selected Childs:", this.selectedChild);
  
    // Refresh the selectpicker dropdown
    setTimeout(() => {
      $('#childlist').selectpicker('refresh');
    }, 0);  // SetTimeout of 0 instead of 10ms
  }
  

  async updateEntry() {
    // let sDate = $('.dataRangePicker').val().split(' to ');
    const start = this.dateRange.split('to')[0].trim();
    const end = this.dateRange.split('to')[1].trim();
    if (this.ri.percOrDisc !== 'Service Cost') {
      this.ri.applyOn = '-';
    }
    // console.log(sDate);
    // let start_date = sDate[0];
    // let end_date = sDate[1];
    if (this.action.trim() == 'add') {
      this.notifier.loading(true);
      let data: any = {
        a: 'add',
        companyName: this.selectedOption.name,
        mid: this.selectedOption.id,
        lids: this.selectedChild,
        percOrDisc: this.ri.percOrDisc,
        applyOn: this.ri.applyOn,
        ramp: this.ri.percOrDisc === 'SP Cost' ? (this.ri.ramp ? 'Yes' : 'No') : '',
        discount: this.ri.discount,
        startDate: start,
        endDate: end,
      };

      let header = {
        Authorization: localStorage.getItem('t'),
      };
      let apiURL = `https://api.swayam.cloud/v3/admin/billing/sp-non-slab`;

      let result = await this.apiService.postDataPromis(apiURL, data, header);

      if (result.status == '1' || result.s == '1') {
        this.notifier.alert('Success', '', result.msg, 'success', 5000);
        this.close(true);
      } else {
        this.notifier.alert('Info', '', result.msg, 'info', 5000);
      }

      this.notifier.loading(false);
    } else {
      this.notifier.loading(true);
      let data: any = {
        a: 'update',
        mid: this.ri.mid,
        lids: this.selectedChild,
        percOrDisc: this.ri.percOrDisc,
        applyOn: this.ri.applyOn,
        ramp: this.ri.percOrDisc === 'SP Cost' ? (this.ri.ramp ? 'Yes' : 'No') : '',
        discount: this.ri.discount,
        startDate: start,
        endDate: end,
      };

      let header = {
        Authorization: localStorage.getItem('t'),
      };
      let apiURL = `https://api.swayam.cloud/v3/admin/billing/sp-non-slab`;

      let result = await this.apiService.postDataPromis(apiURL, data, header);

      if (result.status == '1' || result.s == '1') {
        this.notifier.alert('Success', '', result.msg, 'success', 5000);
        this.close(true);
      } else {
        this.notifier.alert('Info', '', result.msg, 'info', 5000);
      }

      this.notifier.loading(false);
    }
  }

  display() {
    console.log('this.selectedChild', this.selectedChild);
  }

  ngOnDestroy(): void {}

  trackByFn() {
    return true;
  }

  close(dataAction: any) {
    // console.log('close function' + dataAction);
    if (dataAction) {
      this.hideModel.emit(dataAction);
    } else {
      this.hideModel.emit(dataAction);
    }
  }
}
